import React from 'react';
import styles from './PageContentWrapper.module.css';

interface Props {
  children: React.ReactNode;
}

const FixedContentWrapper: React.FC<Props> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default FixedContentWrapper;
